import { useState, useEffect } from "react";
import { supabase } from "./supabaseClient";
const ROLES=[{id:"acquisitions",label:"Acquisitions",color:"#38BDF8",desc:"Full CRM, pipeline, AI agent. No settings or billing."},{id:"cold_caller",label:"Cold Caller",color:"#4ADE80",desc:"Intake form only. Submits leads, sees nothing else."},{id:"readonly",label:"Read Only",color:"#C084FC",desc:"Views dashboard only. Cannot edit anything."}];
const RMAP={owner:{label:"Owner",color:"#F87171"},acquisitions:{label:"Acquisitions",color:"#38BDF8"},caller:{label:"Cold Caller",color:"#4ADE80"},cold_caller:{label:"Cold Caller",color:"#4ADE80"},readonly:{label:"Read Only",color:"#C084FC"}};


const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://wholesaleiq-backend-production-aedc.up.railway.app";
const STRIPE_KEY  = process.env.REACT_APP_STRIPE_KEY  || "";

function BillingSection({ subscription, currentUser, TIER_INFO, card }) {
  const [redeeming, setRedeeming] = useState(false);
  const [code, setCode]           = useState("");
  const [codeMsg, setCodeMsg]     = useState("");
  const [upgrading, setUpgrading] = useState(false);

  const tier    = subscription?.tier   || "starter";
  const status  = subscription?.status || "none";
  const isActive= ["active","trialing"].includes(status);

  const PLANS = [
    { id:"starter", label:"Starter", price:"$49.99/mo", color:"#5A8A60",
      features:["250 leads","1 market","20 Rentcast/mo","Cold caller intake"] },
    { id:"pro",     label:"Pro",     price:"$119.99/mo", color:"#9B7ED4",
      features:["Unlimited leads","3 markets","75 Rentcast/mo","500 SMS/mo","3 team members"] },
    { id:"team",    label:"Team",    price:"$199.99/mo", color:"#C9A96E",
      features:["Unlimited leads","Unlimited markets","300 Rentcast/mo","2000 SMS/mo","10 team members"] },
  ];

  const PRICE_IDS = {
    starter: "price_1TFqqxFY6htG3tXMeEwBcgJ7",
    pro:     "price_1TFqrKFY6htG3tXM1uf6RkRR",
    team:    "price_1TFqrhFY6htG3tXMrBTlCiKo",
  };

  const startCheckout = async (planId) => {
    if (planId === tier && isActive) return;
    setUpgrading(true);
    try {
      const res = await fetch(`${BACKEND_URL}/api/stripe/checkout`, {
        method:"POST", headers:{"Content-Type":"application/json"},
        body: JSON.stringify({
          tier: planId,
          userId: currentUser?.id,
          email:  currentUser?.email,
          successUrl: window.location.origin + "/?upgraded=1",
          cancelUrl:  window.location.origin + "/",
        }),
      });
      const data = await res.json();
      if (data.url) window.location.href = data.url;
      else setCodeMsg("Checkout failed. Try again.");
    } catch(e) { setCodeMsg("Network error."); }
    finally { setUpgrading(false); }
  };

  const redeemCode = async () => {
    if (!code.trim()) return;
    setRedeeming(true); setCodeMsg("");
    try {
      const res = await fetch(`${BACKEND_URL}/api/redeem-code`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code: code.trim(), userId: currentUser?.id }),
      });
      const data = await res.json();
      if (!res.ok) { setCodeMsg(data.error || "Invalid code."); return; }
      setCodeMsg(`✓ ${data.days}-day Pro access activated! Refresh to see changes.`);
      setCode("");
    } catch(e) { setCodeMsg("Network error. Try again."); }
    finally { setRedeeming(false); }
  };

  const ls = { display:"block", fontSize:10, fontFamily:"DM Mono,monospace", color:"#64748B", letterSpacing:1, marginBottom:6 };
  const inp = { width:"100%", boxSizing:"border-box", background:"#090E16", border:"1px solid #1E293B", borderRadius:8, padding:"9px 12px", color:"#F1F5F9", fontSize:13, fontFamily:"DM Sans,sans-serif", outline:"none" };

  return (
    <div style={{...card, marginBottom:16}}>
      <div style={{fontSize:9,letterSpacing:3,color:"#475569",fontFamily:"DM Mono,monospace",marginBottom:16}}>BILLING & SUBSCRIPTION</div>

      {/* Plan tiles */}
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10,marginBottom:20}}>
        {PLANS.map(p => {
          const isCurrent = p.id === tier && isActive;
          return (
            <div key={p.id} style={{background: isCurrent ? p.color+"14" : "#090E16", border:`1px solid ${isCurrent ? p.color : "#1E293B"}`, borderRadius:10, padding:"14px 12px", cursor: isCurrent?"default":"pointer", transition:"border .2s"}}
              onClick={() => !isCurrent && startCheckout(p.id)}>
              <div style={{fontSize:11,fontWeight:700,color:isCurrent?p.color:"#94A3B8",marginBottom:4,fontFamily:"DM Mono,monospace"}}>{p.label.toUpperCase()}</div>
              <div style={{fontSize:18,fontWeight:900,color:"#F1F5F9",marginBottom:8}}>{p.price}</div>
              {p.features.map((f,i) => <div key={i} style={{fontSize:11,color:"#64748B",marginBottom:3}}>✓ {f}</div>)}
              {isCurrent
                ? <div style={{marginTop:10,fontSize:10,fontWeight:700,color:p.color,fontFamily:"DM Mono,monospace"}}>CURRENT PLAN</div>
                : <div style={{marginTop:10,fontSize:10,fontWeight:700,color:"#38BDF8",fontFamily:"DM Mono,monospace",cursor:"pointer"}}>{upgrading?"LOADING...":"UPGRADE →"}</div>
              }
            </div>
          );
        })}
      </div>


    </div>
  );
}

function NotifSection({ currentUser, card }) {
  const PREFS_KEY = `notif_prefs_${currentUser?.id}`;
  const defaultPrefs = { hotLead:true, followUp:true, newMember:true, leadSubmit:true, weeklyReport:false };
  const [prefs, setPrefs] = useState(() => {
    try { return JSON.parse(localStorage.getItem(PREFS_KEY)) || defaultPrefs; }
    catch { return defaultPrefs; }
  });
  const [saved, setSaved] = useState(false);

  const toggle = (key) => {
    const next = { ...prefs, [key]: !prefs[key] };
    setPrefs(next);
    localStorage.setItem(PREFS_KEY, JSON.stringify(next));
    setSaved(true);
    setTimeout(() => setSaved(false), 1500);
  };

  const ITEMS = [
    { key:"hotLead",      label:"Hot lead alert",          desc:"Notify when a lead is scored 80+" },
    { key:"followUp",     label:"Follow-up reminders",     desc:"Alert when a follow-up is overdue" },
    { key:"newMember",    label:"New team member",         desc:"When someone accepts your invite" },
    { key:"leadSubmit",   label:"Cold caller submission",  desc:"When a lead is submitted via intake form" },
    { key:"weeklyReport", label:"Weekly pipeline report",  desc:"Summary of activity every Monday" },
  ];

  return (
    <div style={{...card, marginBottom:16}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
        <div style={{fontSize:9,letterSpacing:3,color:"#475569",fontFamily:"DM Mono,monospace"}}>NOTIFICATION PREFERENCES</div>
        {saved && <div style={{fontSize:10,color:"#4ADE80",fontFamily:"DM Mono,monospace"}}>✓ SAVED</div>}
      </div>
      {ITEMS.map(({key,label,desc}) => (
        <div key={key} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"12px 0",borderBottom:"1px solid #1E293B"}}>
          <div>
            <div style={{fontSize:13,fontWeight:600,color:"#CBD5E1",marginBottom:2}}>{label}</div>
            <div style={{fontSize:11,color:"#475569"}}>{desc}</div>
          </div>
          <div onClick={()=>toggle(key)} style={{width:40,height:22,borderRadius:11,background:prefs[key]?"#38BDF8":"#1E293B",border:`1px solid ${prefs[key]?"#38BDF8":"#334155"}`,cursor:"pointer",position:"relative",transition:"background .2s",flexShrink:0,marginLeft:16}}>
            <div style={{position:"absolute",top:2,left:prefs[key]?20:2,width:16,height:16,borderRadius:"50%",background:prefs[key]?"#fff":"#475569",transition:"left .2s"}}/>
          </div>
        </div>
      ))}
      <div style={{marginTop:12,fontSize:11,color:"#334155"}}>In-app notifications coming soon. Email alerts require Pro plan.</div>
    </div>
  );
}

export default function Settings({currentUser, subscription: propSubscription}){
  const [tab,setTab]=useState("team");
  const [team,setTeam]=useState(null);
  const [members,setMembers]=useState([]);
  const [inviteEmail,setInviteEmail]=useState("");
  const [inviteRole,setInviteRole]=useState("acquisitions");
  const [inviting,setInviting]=useState(false);
  const [msg,setMsg]=useState("");
  const [copied,setCopied]=useState(null);
  const [callerName,setCallerName]=useState("");
  const [loading,setLoading]=useState(true);
  const [pendingInvites,setPendingInvites]=useState([]);
  const [resendingInvite,setResendingInvite]=useState(null); // email being resent
  const [subscription, setSubscription] = useState(propSubscription||null);
  const [adminEmail, setAdminEmail] = useState("");
  const [adminDays, setAdminDays] = useState(30);
  const [adminPlan, setAdminPlan] = useState("pro");
  const [adminLoading, setAdminLoading] = useState(false);
  const [adminResult, setAdminResult] = useState(null);
  const [adminError, setAdminError] = useState("");
  const [lookupEmail, setLookupEmail] = useState("");
  const [lookupLoading, setLookupLoading] = useState(false);
  const [lookupResult, setLookupResult] = useState(null);
  const [lookupError, setLookupError] = useState("");
  const [roster, setRoster] = useState([]);
  const [rosterLoading, setRosterLoading] = useState(false);
  const userId=currentUser?.id;
  // Sync subscription from parent App.jsx state
  useState(()=>{ if(propSubscription) setSubscription(propSubscription); });
  const baseUrl="https://wholesale-iq.vercel.app/intake";
  const intakeUrl=team&&currentUser?.id?baseUrl+"?team="+team.id+"&owner="+currentUser.id:"";
  const callerUrl=callerName.trim()&&team?baseUrl+"?team="+team.id+"&owner="+currentUser.id+"&caller="+encodeURIComponent(callerName.trim()):intakeUrl;

  



  useEffect(()=>{
    if(!userId)return;
    (async()=>{
      setLoading(true);
      const safetyTimer = setTimeout(() => setLoading(false), 6000);
      try {
        let{data:teams,error:teamsErr}=await supabase.from("teams").select("*").eq("owner_id",userId).order("created_at",{ascending:true}).limit(1);
        if(teamsErr)console.error("Teams fetch error:",teamsErr);
        let ownedTeam=teams&&teams.length>0?teams[0]:null;
        if(!ownedTeam){
          const{data:nt,error:insertErr}=await supabase.from("teams").insert({owner_id:userId,name:"My Team"}).select().maybeSingle();
          if(insertErr)console.error("Team insert error:",insertErr);
          ownedTeam=nt;
        }
        setTeam(ownedTeam);
        // Fetch subscription directly
        const{data:sub}=await supabase.from("subscriptions").select("tier,status,expires_at").eq("user_id",userId).maybeSingle();
        if(sub) setSubscription(sub);
        if(ownedTeam){
          const{data:md}=await supabase.from("team_members").select("*").eq("team_id",ownedTeam.id).order("invited_at",{ascending:true,nullsFirst:false});
          setMembers(md||[]);
          const{data:inv}=await supabase.from("invitations").select("email,role,token,expires_at,created_at").eq("team_id",ownedTeam.id).eq("accepted",false).gt("expires_at",new Date().toISOString()).order("created_at",{ascending:false});
          setPendingInvites(inv||[]);
        }
      } catch(e){
        console.error("Settings load error:",e);
      } finally {
        clearTimeout(safetyTimer);
        setLoading(false);
      }
    })();
    // subscription loaded by App.jsx and passed as prop
  },[userId]);

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://wholesaleiq-backend-production-aedc.up.railway.app";

  const ADMIN_SECRET = process.env.REACT_APP_ADMIN_SECRET || "";

  const adminFetch = (path, method="GET", body=null) =>
    fetch(`${BACKEND_URL}${path}`, {
      method,
      headers: {"Content-Type":"application/json","x-admin-secret":ADMIN_SECRET},
      ...(body ? {body:JSON.stringify(body)} : {})
    }).then(r=>r.json());

  const grantTrial = async () => {
    if(!adminEmail){setAdminError("Email required");return;}
    setAdminLoading(true);setAdminResult(null);setAdminError("");
    try {
      const data = await adminFetch("/api/admin/grant-trial","POST",{email:adminEmail,days:Number(adminDays),plan:adminPlan});
      if(data.error) setAdminError(data.error);
      else {setAdminResult(data);setAdminEmail("");}
    } catch(e){setAdminError(e.message);}
    setAdminLoading(false);
  };

  const lookupUser = async () => {
    if(!lookupEmail){setLookupError("Email required");return;}
    setLookupLoading(true);setLookupResult(null);setLookupError("");
    try {
      const data = await adminFetch(`/api/admin/user?email=${encodeURIComponent(lookupEmail)}`);
      if(data.error) setLookupError(data.error);
      else setLookupResult(data);
    } catch(e){setLookupError(e.message);}
    setLookupLoading(false);
  };

  const loadRoster = async () => {
    setRosterLoading(true);
    try {
      // Load all team_members with their team info
      const { data: members } = await supabase
        .from("team_members")
        .select("user_id, email, role, status, team_id, created_at")
        .eq("status", "active")
        .order("created_at", { ascending: true });

      // Load all teams
      const { data: teams } = await supabase
        .from("teams")
        .select("id, name, owner_id");

      // Load all subscriptions
      const { data: subs } = await supabase
        .from("subscriptions")
        .select("user_id, tier, status, trial_end");

      // Build roster — group members by team
      const teamMap = {};
      (teams || []).forEach(t => { teamMap[t.id] = { ...t, members: [] }; });
      (members || []).forEach(m => {
        if (teamMap[m.team_id]) teamMap[m.team_id].members.push(m);
      });

      const subMap = {};
      (subs || []).forEach(s => { subMap[s.user_id] = s; });

      const result = Object.values(teamMap).map(t => ({
        ...t,
        ownerSub: subMap[t.owner_id] || null,
      }));

      setRoster(result);
    } catch(e) { console.error("Roster load error:", e); }
    setRosterLoading(false);
  };

  const refreshSubscription = () => {
    if(!userId)return;
    fetch(`${BACKEND_URL}/api/stripe/subscription/${userId}`)
      .then(r=>r.json())
      .then(data=>setSubscription(data))
      .catch(()=>{});
  };

  const MEMBER_LIMITS = { starter:3, pro:10, team:25 };

  const inviteMember=async()=>{
    if(!inviteEmail.trim()||!team)return;
    setInviting(true);setMsg("");
    if(members.find(m=>m.email.toLowerCase()===inviteEmail.toLowerCase()&&m.status==="active")){setMsg("Already an active team member.");setInviting(false);return;}
    // Check member limit for current plan
    const currentTier = subscription?.tier || "starter";
    const limit = MEMBER_LIMITS[currentTier] || 1;
    const activeCount = members.filter(m=>m.status==="active"&&m.role!=="owner").length;
    if(activeCount >= limit){
      setMsg(`Your ${currentTier} plan allows ${limit} member${limit>1?"s":""}. Upgrade to add more.`);
      setInviting(false);
      return;
    }
    try {
      const res = await fetch(`${BACKEND_URL}/api/invite`, {
        method: "POST",
        headers: {"Content-Type":"application/json"},
        body: JSON.stringify({
          teamId: team.id,
          email: inviteEmail.trim().toLowerCase(),
          role: inviteRole,
          inviterName: currentUser?.email
        })
      });
      const data = await res.json();
      if (!data.success) throw new Error(data.error || "Invite failed");
      setMembers(prev=>[...prev,{email:inviteEmail.trim().toLowerCase(),role:inviteRole,status:"pending",invited_at:new Date().toISOString()}]);
      setInviteEmail("");
      setMsg("✅ Invite sent to " + inviteEmail.trim().toLowerCase());
    } catch(e) {
      setMsg("Error: " + e.message);
    }
    setInviting(false);
  };
  const resendInvite=async(email,role)=>{
    if(!team)return;
    setResendingInvite(email);
    // Delete old invite first
    await supabase.from("invitations").delete().eq("team_id",team.id).eq("email",email);
    // Send fresh invite via backend
    try {
      const res=await fetch(`${BACKEND_URL}/api/invite`,{
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({teamId:team.id,email,role,inviterName:currentUser?.email})
      });
      const data=await res.json();
      if(data.success){
        // Refresh pending invites
        const{data:inv}=await supabase.from("invitations").select("email,role,token,expires_at,created_at").eq("team_id",team.id).eq("accepted",false).gt("expires_at",new Date().toISOString()).order("created_at",{ascending:false});
        setPendingInvites(inv||[]);
        setMsg("✅ Invite resent to "+email);
      } else { setMsg("Error: "+(data.error||"Failed")); }
    } catch(e){ setMsg("Error: "+e.message); }
    setResendingInvite(null);
    setTimeout(()=>setMsg(""),3000);
  };

  const cancelInvite=async(email)=>{
    if(!team)return;
    await supabase.from("invitations").delete().eq("team_id",team.id).eq("email",email);
    setPendingInvites(prev=>prev.filter(i=>i.email!==email));
  };

  const removeMember=async(email)=>{if(!team)return;await supabase.from("team_members").delete().eq("team_id",team.id).eq("email",email);setMembers(prev=>prev.filter(m=>m.email!==email));};
  const updateRole=async(email,r)=>{if(!team)return;await supabase.from("team_members").update({role:r}).eq("team_id",team.id).eq("email",email);setMembers(prev=>prev.map(m=>m.email===email?{...m,role:r}:m));};
  const copy=(text,id)=>{navigator.clipboard.writeText(text);setCopied(id);setTimeout(()=>setCopied(null),2000);};
  const signupLink=team?"https://wholesale-iq.vercel.app/accept-invite?team="+team.id:"";
  const card={background:"#080D14",border:"1px solid #1E293B",borderRadius:10,padding:"20px 22px",marginBottom:16};
  const fs={width:"100%",boxSizing:"border-box",background:"#090E16",border:"1px solid #1E293B",borderRadius:8,padding:"10px 12px",color:"#F1F5F9",fontSize:13,outline:"none"};
  const ls={display:"block",fontSize:10,fontFamily:"DM Mono,monospace",color:"#64748B",letterSpacing:1,marginBottom:8};

  const TIER_INFO = {
    starter: { label:"Starter", color:"#5A8A60", price:"$49.99/mo", features:["250 leads","1 market","20 Rentcast calls","No SMS"] },
    pro:     { label:"Pro",     color:"#9B7ED4", price:"$119.99/mo", features:["Unlimited leads","3 markets","75 Rentcast calls","500 SMS/mo"] },
    team:    { label:"Team",    color:"#C9A96E", price:"$199.99/mo", features:["Unlimited leads","Unlimited markets","300 Rentcast calls","2000 SMS/mo","Up to 10 members"] },
  };
  if(loading)return(<div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",background:"#060A10"}}><div style={{width:28,height:28,border:"2px solid #1E293B",borderTopColor:"#38BDF8",borderRadius:"50%",animation:"spin .7s linear infinite"}}/><style>{"@keyframes spin{to{transform:rotate(360deg)}}"}</style></div>);

  return(
    <div style={{flex:1,overflowY:"auto",padding:24,background:"#060A10",fontFamily:"DM Sans,sans-serif",color:"#F1F5F9"}}>
      <div style={{marginBottom:24}}>
        <div style={{fontSize:9,letterSpacing:3,color:"#334155",fontFamily:"DM Mono,monospace",marginBottom:4}}>WHOLESALEIQ</div>
        <div style={{fontSize:28,letterSpacing:3,color:"#F1F5F9",fontWeight:900}}>SETTINGS</div>
      </div>
      <div style={{display:"flex",gap:2,borderBottom:"1px solid #1E293B",marginBottom:24}}>
        {[["team","Team & Roles"],["intake","Cold Caller Intake"],["account","Account"],...(currentUser?.email?.toLowerCase()==="cody@coast2coastequity.com"?[["admin","Admin"]]:[])].map(([id,label])=>(
          <button key={id} onClick={()=>setTab(id)} style={{background:"none",border:"none",padding:"10px 16px",fontSize:12,cursor:"pointer",fontFamily:"DM Mono,monospace",color:tab===id?"#38BDF8":"#475569",borderBottom:tab===id?"2px solid #38BDF8":"2px solid transparent"}}>{label}</button>
        ))}
      </div>

      {tab==="team"&&(
        <div style={{maxWidth:700}}>
          <div style={card}>
            <div style={{fontSize:9,letterSpacing:3,color:"#475569",fontFamily:"DM Mono,monospace",marginBottom:16}}>TEAM MEMBERS</div>
            {members.length===0?(<div style={{textAlign:"center",padding:"20px 0",color:"#334155",fontSize:13}}>No team members yet</div>):(
              members.map((m,i)=>{
                const ri=RMAP[m.role]||RMAP.readonly;
                const isOwner=m.role==="owner";
                return(
                  <div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 0",borderBottom:i<members.length-1?"1px solid #1E293B":"none"}}>
                    <div style={{width:36,height:36,borderRadius:"50%",background:ri.color+"22",border:"1px solid "+ri.color+"44",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                      <span style={{fontSize:13,fontWeight:700,color:ri.color}}>{m.email.charAt(0).toUpperCase()}</span>
                    </div>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontSize:13,color:"#F1F5F9",fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{m.email}</div>
                      <div style={{display:"flex",alignItems:"center",gap:8,marginTop:3}}>
                        <span style={{fontSize:10,fontFamily:"DM Mono,monospace",background:ri.color+"18",color:ri.color,borderRadius:4,padding:"2px 7px",fontWeight:600}}>{ri.label}</span>
                        <span style={{fontSize:10,color:m.status==="active"?"#4ADE80":"#FB923C",fontFamily:"DM Mono,monospace"}}>{m.status==="active"?"Active":"Pending"}</span>
                      </div>
                    </div>
                    {!isOwner&&(
                      <div style={{display:"flex",gap:8,flexShrink:0}}>
                        <select value={m.role} onChange={e=>updateRole(m.email,e.target.value)} style={{background:"#1E293B",border:"1px solid #334155",borderRadius:6,color:"#CBD5E1",padding:"5px 8px",fontSize:11,cursor:"pointer"}}>
                          {ROLES.map(r=><option key={r.id} value={r.id}>{r.label}</option>)}
                        </select>
                        <button onClick={()=>removeMember(m.email)} style={{background:"#F8717111",border:"1px solid #F8717133",borderRadius:6,color:"#F87171",padding:"5px 10px",cursor:"pointer",fontSize:11}}>Remove</button>
                      </div>
                    )}
                  </div>
                );
              })
            )}
          </div>
          {pendingInvites.length>0&&(
            <div style={{...card,border:"1px solid #FB923C33"}}>
              <div style={{fontSize:9,letterSpacing:3,color:"#FB923C",fontFamily:"DM Mono,monospace",marginBottom:16}}>
                PENDING INVITES <span style={{fontSize:9,color:"#475569"}}>({pendingInvites.length})</span>
              </div>
              {pendingInvites.map((inv,i)=>{
                const ri=RMAP[inv.role]||RMAP.readonly;
                const expires=new Date(inv.expires_at);
                const daysLeft=Math.ceil((expires-new Date())/(1000*60*60*24));
                const isResending=resendingInvite===inv.email;
                return(
                  <div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 0",borderBottom:i<pendingInvites.length-1?"1px solid #1E293B":"none"}}>
                    <div style={{width:36,height:36,borderRadius:"50%",background:"#FB923C22",border:"1px solid #FB923C44",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                      <span style={{fontSize:13,fontWeight:700,color:"#FB923C"}}>{inv.email.charAt(0).toUpperCase()}</span>
                    </div>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontSize:13,color:"#F1F5F9",fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{inv.email}</div>
                      <div style={{display:"flex",alignItems:"center",gap:8,marginTop:3}}>
                        <span style={{fontSize:10,fontFamily:"DM Mono,monospace",background:ri.color+"18",color:ri.color,borderRadius:4,padding:"2px 7px",fontWeight:600}}>{ri.label}</span>
                        <span style={{fontSize:10,color:daysLeft<=1?"#F87171":"#FB923C",fontFamily:"DM Mono,monospace"}}>
                          {daysLeft<=0?"Expired":daysLeft===1?"Expires today":`Expires in ${daysLeft}d`}
                        </span>
                      </div>
                    </div>
                    <div style={{display:"flex",gap:6,flexShrink:0}}>
                      <button onClick={()=>resendInvite(inv.email,inv.role)} disabled={isResending}
                        style={{background:"#38BDF814",border:"1px solid #38BDF833",borderRadius:6,color:"#38BDF8",padding:"5px 10px",cursor:"pointer",fontSize:11,fontWeight:700,fontFamily:"DM Mono,monospace",opacity:isResending?0.5:1}}>
                        {isResending?"...":"↺ RESEND"}
                      </button>
                      <button onClick={()=>cancelInvite(inv.email)}
                        style={{background:"#F8717111",border:"1px solid #F8717133",borderRadius:6,color:"#F87171",padding:"5px 10px",cursor:"pointer",fontSize:11}}>
                        ✕
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          <div style={card}>
            <div style={{fontSize:9,letterSpacing:3,color:"#475569",fontFamily:"DM Mono,monospace",marginBottom:16}}>INVITE TEAM MEMBER</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr auto",gap:10,marginBottom:12}}>
              <div><label style={ls}>EMAIL</label><input value={inviteEmail} onChange={e=>setInviteEmail(e.target.value)} onKeyDown={e=>e.key==="Enter"&&inviteMember()} placeholder="maria@example.com" style={fs}/></div>
              <div><label style={ls}>ROLE</label><select value={inviteRole} onChange={e=>setInviteRole(e.target.value)} style={{background:"#090E16",border:"1px solid #1E293B",borderRadius:8,padding:"10px 12px",color:"#F1F5F9",fontSize:13,cursor:"pointer",height:42}}>{ROLES.map(r=><option key={r.id} value={r.id}>{r.label}</option>)}</select></div>
            </div>
            <div style={{background:"#090E16",border:"1px solid #1E293B",borderRadius:8,padding:12,marginBottom:14}}>
              {ROLES.map(r=>(
                <div key={r.id} style={{display:"flex",gap:10,padding:"6px 0",borderBottom:"1px solid #1E293B"}}>
                  <span style={{fontSize:10,fontFamily:"DM Mono,monospace",background:r.color+"18",color:r.color,borderRadius:4,padding:"2px 8px",flexShrink:0}}>{r.label}</span>
                  <span style={{fontSize:12,color:"#64748B"}}>{r.desc}</span>
                </div>
              ))}
            </div>
            <button onClick={inviteMember} disabled={inviting||!inviteEmail.trim()} style={{background:!inviteEmail.trim()?"#1E293B":"linear-gradient(135deg,#38BDF8,#0284C7)",border:"none",borderRadius:8,color:!inviteEmail.trim()?"#334155":"#080D14",padding:"11px 24px",cursor:!inviteEmail.trim()?"not-allowed":"pointer",fontSize:12,fontWeight:800}}>
              {inviting?"INVITING...":"+ ADD TO TEAM"}
            </button>
            {msg&&<div style={{marginTop:10,fontSize:13,color:msg.startsWith("✅")||msg.startsWith("✓")?"#4ADE80":"#F87171"}}>{msg}</div>}
          </div>
          <div style={{...card,border:"1px solid #38BDF833"}}>
            <div style={{fontSize:9,letterSpacing:3,color:"#38BDF8",fontFamily:"DM Mono,monospace",marginBottom:12}}>TEAM SIGNUP LINK</div>
            <div style={{fontSize:12,color:"#64748B",marginBottom:14}}>Send this to invited team members so they can create their account.</div>
            <div style={{display:"flex",gap:8}}>
              <div style={{flex:1,background:"#090E16",border:"1px solid #1E293B",borderRadius:8,padding:"10px 14px",fontSize:11,color:"#38BDF8",fontFamily:"DM Mono,monospace",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{signupLink}</div>
              <button onClick={()=>copy(signupLink,"signup")} style={{background:copied==="signup"?"#4ADE8022":"#38BDF814",border:"1px solid "+(copied==="signup"?"#4ADE80":"#38BDF833"),borderRadius:8,color:copied==="signup"?"#4ADE80":"#38BDF8",padding:"10px 16px",cursor:"pointer",fontSize:11,fontWeight:700,whiteSpace:"nowrap"}}>{copied==="signup"?"COPIED":"COPY"}</button>
            </div>
          </div>
        </div>
      )}

      {tab==="intake"&&(
        <div style={{maxWidth:600}}>
          <div style={card}>
            <div style={{fontSize:15,fontWeight:700,color:"#F1F5F9",marginBottom:6}}>Lead Intake Form</div>
            <div style={{fontSize:13,color:"#64748B",marginBottom:20}}>Share with cold callers. Leads appear instantly in Pipeline — no login needed.</div>
            <div style={{marginBottom:20}}>
              <label style={ls}>YOUR INTAKE LINK</label>
              <div style={{display:"flex",gap:8}}>
                <div style={{flex:1,background:"#090E16",border:"1px solid #1E293B",borderRadius:8,padding:"10px 14px",fontSize:11,color:"#38BDF8",fontFamily:"DM Mono,monospace",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{intakeUrl}</div>
                <button onClick={()=>copy(intakeUrl,"intake")} style={{background:copied==="intake"?"#4ADE8022":"#38BDF814",border:"1px solid "+(copied==="intake"?"#4ADE80":"#38BDF833"),borderRadius:8,color:copied==="intake"?"#4ADE80":"#38BDF8",padding:"10px 16px",cursor:"pointer",fontSize:11,fontWeight:700,whiteSpace:"nowrap"}}>{copied==="intake"?"COPIED":"COPY"}</button>
                <a href={intakeUrl} target="_blank" rel="noreferrer" style={{background:"#1E293B",border:"1px solid #334155",borderRadius:8,color:"#94A3B8",padding:"10px 16px",fontSize:11,fontWeight:700,textDecoration:"none",whiteSpace:"nowrap"}}>PREVIEW</a>
              </div>
            </div>
            <div style={{background:"#090E16",border:"1px solid #1E293B",borderRadius:10,padding:16}}>
              <div style={{fontSize:11,fontWeight:700,color:"#CBD5E1",marginBottom:12}}>Generate per-caller link</div>
              <div style={{display:"flex",gap:10}}>
                <input value={callerName} onChange={e=>setCallerName(e.target.value)} placeholder="Caller name e.g. Maria" style={{...fs,flex:1}}/>
                <button onClick={()=>copy(callerUrl,"caller")} disabled={!callerName.trim()} style={{background:!callerName.trim()?"#1E293B":"#38BDF814",border:"1px solid "+(callerName.trim()?"#38BDF833":"#334155"),borderRadius:8,color:callerName.trim()?"#38BDF8":"#334155",padding:"10px 16px",cursor:callerName.trim()?"pointer":"not-allowed",fontSize:11,fontWeight:700,whiteSpace:"nowrap"}}>{copied==="caller"?"COPIED":"COPY LINK"}</button>
              </div>
              {callerName.trim()&&<div style={{marginTop:10,fontSize:11,color:"#475569",fontFamily:"DM Mono,monospace",wordBreak:"break-all"}}>{callerUrl}</div>}
            </div>
          </div>
        </div>
      )}

      {tab==="admin"&&(
        <div style={{maxWidth:560}}>
          {/* Grant Trial */}
          <div style={{...card,border:"1px solid #C9A96E33",marginBottom:16}}>
            <div style={{fontSize:9,letterSpacing:3,color:"#C9A96E",fontFamily:"DM Mono,monospace",marginBottom:16}}>GRANT BETA ACCESS</div>
            <div style={{display:"grid",gap:10,marginBottom:12}}>
              <div><label style={ls}>USER EMAIL</label><input value={adminEmail} onChange={e=>setAdminEmail(e.target.value)} placeholder="user@example.com" style={fs}/></div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                <div><label style={ls}>PLAN</label>
                  <select value={adminPlan} onChange={e=>setAdminPlan(e.target.value)} style={{...fs,cursor:"pointer"}}>
                    <option value="starter">Starter</option>
                    <option value="pro">Pro</option>
                    <option value="team">Team</option>
                  </select>
                </div>
                <div><label style={ls}>DAYS</label>
                  <select value={adminDays} onChange={e=>setAdminDays(e.target.value)} style={{...fs,cursor:"pointer"}}>
                    <option value={30}>30 days</option>
                    <option value={60}>60 days</option>
                    <option value={90}>90 days</option>
                    <option value={365}>365 days</option>
                  </select>
                </div>
              </div>
            </div>
            <button onClick={grantTrial} disabled={adminLoading} style={{background:adminLoading?"#1E293B":"linear-gradient(135deg,#C9A96E,#A8834A)",border:"none",borderRadius:8,color:adminLoading?"#334155":"#0F0F11",padding:"11px 24px",cursor:adminLoading?"not-allowed":"pointer",fontSize:12,fontWeight:800,fontFamily:"DM Mono,monospace"}}>
              {adminLoading?"GRANTING...":"GRANT ACCESS →"}
            </button>
            {adminError&&<div style={{marginTop:10,fontSize:12,color:"#F87171",fontFamily:"DM Mono,monospace"}}>⚠ {adminError}</div>}
            {adminResult&&<div style={{marginTop:10,fontSize:12,color:"#4ADE80",fontFamily:"DM Mono,monospace"}}>✓ {adminResult.days||adminDays}-day {adminResult.plan||adminPlan} trial granted to {adminResult.email}</div>}
          </div>

          {/* User Lookup */}
          <div style={{...card,border:"1px solid #38BDF833",marginBottom:16}}>
            <div style={{fontSize:9,letterSpacing:3,color:"#38BDF8",fontFamily:"DM Mono,monospace",marginBottom:16}}>USER LOOKUP</div>
            <div style={{display:"flex",gap:8,marginBottom:12}}>
              <input value={lookupEmail} onChange={e=>setLookupEmail(e.target.value)} onKeyDown={e=>e.key==="Enter"&&lookupUser()} placeholder="user@example.com" style={{...fs,flex:1}}/>
              <button onClick={lookupUser} disabled={lookupLoading} style={{background:"#38BDF814",border:"1px solid #38BDF833",borderRadius:8,color:lookupLoading?"#475569":"#38BDF8",padding:"10px 18px",cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"DM Mono,monospace",whiteSpace:"nowrap"}}>
                {lookupLoading?"...":"LOOK UP →"}
              </button>
            </div>
            {lookupError&&<div style={{fontSize:12,color:"#F87171",fontFamily:"DM Mono,monospace"}}>⚠ {lookupError}</div>}
            {lookupResult&&(
              <div style={{display:"grid",gap:8}}>
                <div style={{background:"#090E16",border:"1px solid #1E293B",borderRadius:8,padding:"12px 14px"}}>
                  <div style={{fontSize:9,color:"#475569",fontFamily:"DM Mono,monospace",letterSpacing:1,marginBottom:6}}>USER</div>
                  <div style={{fontSize:13,fontWeight:700,color:"#F1F5F9"}}>{lookupResult.user?.email}</div>
                  <div style={{fontSize:10,color:"#475569",fontFamily:"DM Mono,monospace",marginTop:4}}>ID: {lookupResult.user?.id}</div>
                  <div style={{fontSize:10,color:"#475569",fontFamily:"DM Mono,monospace"}}>Joined: {lookupResult.user?.created_at?new Date(lookupResult.user.created_at).toLocaleDateString():"—"}</div>
                </div>
                <div style={{background:"#090E16",border:"1px solid #1E293B",borderRadius:8,padding:"12px 14px"}}>
                  <div style={{fontSize:9,color:"#475569",fontFamily:"DM Mono,monospace",letterSpacing:1,marginBottom:6}}>SUBSCRIPTION</div>
                  {lookupResult.subscription?(
                    <div>
                      <span style={{fontSize:11,fontWeight:700,color:"#C9A96E",fontFamily:"DM Mono,monospace"}}>{(lookupResult.subscription.tier||"starter").toUpperCase()}</span>
                      <span style={{fontSize:11,color:"#475569",fontFamily:"DM Mono,monospace",marginLeft:10}}>{(lookupResult.subscription.status||"").toUpperCase()}</span>
                      {lookupResult.subscription.trial_end&&<div style={{fontSize:10,color:"#475569",fontFamily:"DM Mono,monospace",marginTop:4}}>Trial ends: {new Date(lookupResult.subscription.trial_end).toLocaleDateString()}</div>}
                    </div>
                  ):<span style={{fontSize:12,color:"#475569"}}>No subscription</span>}
                </div>
                {lookupResult.team&&(
                  <div style={{background:"#090E16",border:"1px solid #1E293B",borderRadius:8,padding:"12px 14px"}}>
                    <div style={{fontSize:9,color:"#475569",fontFamily:"DM Mono,monospace",letterSpacing:1,marginBottom:6}}>TEAM</div>
                    <span style={{fontSize:11,fontWeight:700,color:"#B87AA8",fontFamily:"DM Mono,monospace"}}>{(lookupResult.team.role||"member").toUpperCase()}</span>
                    <span style={{fontSize:10,color:"#475569",fontFamily:"DM Mono,monospace",marginLeft:10}}>Team: {lookupResult.team.team_id}</span>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Active Profiles Roster */}
          <div style={{...card,border:"1px solid #B87AA833"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
              <div style={{fontSize:9,letterSpacing:3,color:"#B87AA8",fontFamily:"DM Mono,monospace"}}>ACTIVE PROFILES & TEAMS</div>
              <button onClick={loadRoster} disabled={rosterLoading} style={{background:"#B87AA814",border:"1px solid #B87AA833",borderRadius:6,color:"#B87AA8",padding:"5px 12px",cursor:"pointer",fontSize:11,fontWeight:700,fontFamily:"DM Mono,monospace"}}>
                {rosterLoading?"LOADING...":"LOAD ROSTER"}
              </button>
            </div>
            {roster.length===0&&!rosterLoading&&(
              <div style={{fontSize:12,color:"#475569",textAlign:"center",padding:"16px 0"}}>Click Load Roster to view all active profiles</div>
            )}
            {roster.map((team,i)=>(
              <div key={team.id} style={{marginBottom:i<roster.length-1?20:0}}>
                {/* Team header */}
                <div style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px",background:"#090E16",border:"1px solid #1E293B",borderRadius:"8px 8px 0 0",borderBottom:"none"}}>
                  <div style={{flex:1}}>
                    <div style={{fontSize:12,fontWeight:700,color:"#F1F5F9"}}>{team.name||"My Team"}</div>
                    <div style={{fontSize:10,color:"#475569",fontFamily:"DM Mono,monospace",marginTop:2}}>
                      Owner ID: {team.owner_id?.slice(0,8)}...
                      {team.ownerSub&&<span style={{marginLeft:10,color:team.ownerSub.tier==="team"?"#C9A96E":team.ownerSub.tier==="pro"?"#9B7ED4":"#5A8A60",fontWeight:700}}> {(team.ownerSub.tier||"starter").toUpperCase()}</span>}
                    </div>
                  </div>
                  <span style={{fontSize:10,background:"#C9A96E18",color:"#C9A96E",border:"1px solid #C9A96E33",borderRadius:4,padding:"2px 8px",fontFamily:"DM Mono,monospace",fontWeight:700}}>OWNER</span>
                </div>
                {/* Members */}
                {team.members.length===0?(
                  <div style={{padding:"10px 14px",background:"#0A0D14",border:"1px solid #1E293B",borderRadius:"0 0 8px 8px",fontSize:11,color:"#334155",fontFamily:"DM Mono,monospace"}}>No team members</div>
                ):(
                  team.members.map((m,j)=>{
                    const RCOLORS={acquisitions:"#38BDF8",cold_caller:"#4ADE80",readonly:"#C084FC",member:"#94A3B8"};
                    const rc=RCOLORS[m.role]||"#94A3B8";
                    return(
                      <div key={m.user_id} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 14px",background:"#0A0D14",border:"1px solid #1E293B",borderTop:"none",borderRadius:j===team.members.length-1?"0 0 8px 8px":0}}>
                        <div style={{width:28,height:28,borderRadius:"50%",background:rc+"18",border:`1px solid ${rc}44`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:800,color:rc,flexShrink:0}}>
                          {(m.email||"?").charAt(0).toUpperCase()}
                        </div>
                        <div style={{flex:1,minWidth:0}}>
                          <div style={{fontSize:12,color:"#F1F5F9",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{m.email||m.user_id?.slice(0,16)}</div>
                          <div style={{fontSize:10,color:"#475569",fontFamily:"DM Mono,monospace",marginTop:2}}>
                            Joined {m.created_at?new Date(m.created_at).toLocaleDateString():"—"}
                          </div>
                        </div>
                        <span style={{fontSize:9,background:rc+"18",color:rc,border:`1px solid ${rc}33`,borderRadius:4,padding:"2px 7px",fontFamily:"DM Mono,monospace",fontWeight:700,flexShrink:0}}>
                          {(m.role||"member").replace("_"," ").toUpperCase()}
                        </span>
                      </div>
                    );
                  })
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {tab==="account"&&(
        <div style={{maxWidth:500}}>
          <div style={card}>
            <div style={{fontSize:9,letterSpacing:3,color:"#475569",fontFamily:"DM Mono,monospace",marginBottom:16}}>YOUR ACCOUNT</div>
            <div style={{display:"flex",alignItems:"center",gap:14,marginBottom:20}}>
              <div style={{width:48,height:48,borderRadius:"50%",background:"#38BDF822",border:"1px solid #38BDF844",display:"flex",alignItems:"center",justifyContent:"center"}}>
                <span style={{fontSize:18,fontWeight:700,color:"#38BDF8"}}>{currentUser?.email?.charAt(0).toUpperCase()}</span>
              </div>
              <div>
                <div style={{fontSize:15,fontWeight:700,color:"#F1F5F9"}}>{currentUser?.email}</div>
                <div style={{fontSize:11,color:"#F87171",fontFamily:"DM Mono,monospace",marginTop:2}}>Owner</div>
              </div>
            </div>
            <div style={{background:"#090E16",border:"1px solid #1E293B",borderRadius:8,padding:"12px 14px"}}>
              <div style={{fontSize:11,color:"#475569",fontFamily:"DM Mono,monospace",marginBottom:4}}>TEAM ID</div>
              <div style={{fontSize:11,color:"#64748B",fontFamily:"DM Mono,monospace",wordBreak:"break-all"}}>{team?.id||"Loading..."}</div>
            </div>
          </div>
          {/* Current Plan */}
          <div style={{...card,border:`1px solid ${(TIER_INFO[subscription?.tier||"starter"]?.color||"#5A8A60")}33`,marginBottom:16}}>
            <div style={{fontSize:9,letterSpacing:3,color:TIER_INFO[subscription?.tier||"starter"]?.color||"#5A8A60",fontFamily:"DM Mono,monospace",marginBottom:16}}>CURRENT PLAN</div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:16}}>
              <div>
                <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:6}}>
                  <span style={{fontSize:22,fontWeight:900,color:"#F1F5F9"}}>{TIER_INFO[subscription?.tier||"starter"]?.label||"Starter"}</span>
                  <span style={{fontSize:10,background:(TIER_INFO[subscription?.tier||"starter"]?.color||"#5A8A60")+"22",color:TIER_INFO[subscription?.tier||"starter"]?.color||"#5A8A60",border:`1px solid ${TIER_INFO[subscription?.tier||"starter"]?.color||"#5A8A60"}44`,borderRadius:4,padding:"2px 8px",fontFamily:"DM Mono,monospace",fontWeight:700}}>
                    {(subscription?.status||"none").toUpperCase()}
                  </span>
                </div>
                <div style={{fontSize:12,color:"#475569"}}>
                  {subscription?.expires_at
                    ? `Expires ${new Date(subscription.expires_at).toLocaleDateString("en-US",{month:"long",day:"numeric",year:"numeric"})}`
                    : subscription?.status==="active" ? "Active subscription" : subscription?.status==="trialing" ? "Free trial" : "No active plan"}
                </div>
              </div>
              <div style={{textAlign:"right"}}>
                <div style={{fontSize:13,fontWeight:700,color:"#64748B"}}>{TIER_INFO[subscription?.tier||"starter"]?.price}</div>
              </div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
              {(TIER_INFO[subscription?.tier||"starter"]?.features||[]).map((f,i)=>(
                <div key={i} style={{display:"flex",alignItems:"center",gap:6,fontSize:12,color:"#94A3B8"}}>
                  <span style={{color:TIER_INFO[subscription?.tier||"starter"]?.color||"#5A8A60",fontSize:14}}>✓</span>{f}
                </div>
              ))}
            </div>
          </div>



          {/* ── Billing & Subscription ── */}
          <BillingSection subscription={subscription} currentUser={currentUser} TIER_INFO={TIER_INFO} card={card}/>
          {/* ── Notification Preferences ── */}
          <NotifSection currentUser={currentUser} card={card}/>
        </div>
      )}
    </div>
  );
}
// Sat Apr 11 16:11:15 CDT 2026
